import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Col, Row, Table, Button, Modal, Form, Tabs, Empty } from "antd";
import { columns, vehicleColumns } from "./columns";
import "./style.css";
import { BUTTONS, FORMS, ROUTES } from "../common/constants";
import CreateVehicleModelForm from "./form";
import { getApis } from "../common/api";
import { partModelListUrl } from "../common/endpoints";
import ChangeOrganisation from "../common/ChangeOrganisation";
import { useSelector } from "react-redux";

const PartModel = () => {
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const orgDetails = useSelector((state) => state.org);
  const [modalOpen, setModalOpen] = useState(false);
  const [modelList, setModelList] = useState();
  const [form] = Form.useForm();

  const viewPartsDetail = (data) => {
    navigate(ROUTES.VEHICLE_MODEL, {
      state: { orgId: orgDetails?.id, vehModelId: data?.partModelId },
    });
  };

  const getPartModelList = useCallback(async () => {
    await getApis(
      partModelListUrl,
      {
        page: 0,
        size: 1000,
      },
      orgDetails?.token || authToken
    )
      .then((response) => {
        if (response?.data?.length > 0) {
          const groupedData = response?.data.reduce((acc, item) => {
            if (!acc[item.partType]) {
              acc[item.partType] = [];
            }
            acc[item.partType].push(item);
            return acc;
          }, {});
          const tabList = Object.keys(groupedData)?.map((part, index) => ({
            key: index,
            label: part,
            children: (
              <Row justify="center">
                <Col span={24}>
                  <Table
                    columns={
                      part === "VEHICLE"
                        ? vehicleColumns(viewPartsDetail)
                        : columns(viewPartsDetail)
                    }
                    rowKey={(record) => record.name}
                    dataSource={groupedData[part]}
                    pagination={
                      groupedData[part].length > 10 ? { pageSize: 10 } : false
                    }
                    scroll={{ x: "100%" }}
                  />
                </Col>
              </Row>
            ),
          }));
          setModelList(tabList);
        } else {
          setModelList([]);
        }
      })
      .catch((error) => console.log(error));
    // eslint-disable-next-line
  }, [orgDetails?.token]);

  useEffect(() => {
    getPartModelList();
  }, [getPartModelList]);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (values) => {
    setModalOpen(false);
  };

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={4} className="head">
          Part Model Management
        </Col>
        <Col span={3}>
          <Button type="primary" onClick={null} disabled>
            {BUTTONS.ADD_NEW}
          </Button>
        </Col>
      </Row>
      <ChangeOrganisation />
      {modelList?.length > 0 ? (
        <Row>
          <Col span={24}>
            <Tabs type="card" items={modelList} className="mt1" />
          </Col>
        </Row>
      ) : (
        <Row justify={"center"} align={"center"} className="bg-white mt1 h100">
          <Col span={24}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="mt2" />
          </Col>
        </Row>
      )}

      <Modal
        title={FORMS.VEHICLE_MODEL.HEADER}
        centered
        open={modalOpen}
        onOk={form.submit}
        onCancel={handleCancel}
        footer={null}
      >
        <CreateVehicleModelForm handleSubmit={handleSubmit} />
      </Modal>
    </>
  );
};

export default PartModel;
